import dayjs from 'dayjs';

export type RemainingTimeFormatted = {
    seconds: string;
    minutes: string;
    isCountdownFinish: boolean;
};
export const defaultRemainingTimeFormatted: RemainingTimeFormatted = {
    seconds: '00',
    minutes: '00',
    isCountdownFinish: false,
};
export const getRemainingTimeUntilMsTimestamp = (timestampMs: number): RemainingTimeFormatted => {
    const timestampDayjs = dayjs(timestampMs);
    const nowDayjs = dayjs();

    if (timestampDayjs.isBefore(nowDayjs)) {
        return {
            ...defaultRemainingTimeFormatted,
            isCountdownFinish: true,
        };
    }
    return {
        seconds: getRemainingSeconds(nowDayjs, timestampDayjs),
        minutes: getRemainingMinutes(nowDayjs, timestampDayjs),
        isCountdownFinish: false,
    };
};

export const getRemainingSeconds = (nowDayjs: dayjs.Dayjs, timestampDayjs: dayjs.Dayjs): string => {
    const seconds = timestampDayjs.diff(nowDayjs, 's') % 60;
    return padWithZeros(seconds, 2);
};

export const getRemainingMinutes = (nowDayjs: dayjs.Dayjs, timestampDayjs: dayjs.Dayjs): string => {
    const minutes = timestampDayjs.diff(nowDayjs, 'minute') % 60;
    return padWithZeros(minutes, 2);
};

export const padWithZeros = (number: number, minLength: number): string => {
    const numberString = number.toString();
    if (numberString.length >= minLength) return numberString;
    return '0'.repeat(minLength - numberString.length) + numberString;
};
export const getCountdownTimeMsTimestamp = (minute: number) => {
    return (
        dayjs()
            .add(minute, 'minute')
            .unix() * 1000
    );
};
